import { IUpdateRequestParams } from './Operations';

/**
 * Formats request parameters by converting the filter array to an OData-style query string.
 * This is a copy of the Analytics RequestFormatting to avoid impacting Analytics functionality.
 */
export const formatRequestParams = (paramsObj: IUpdateRequestParams) => {

    const obj = JSON.parse(JSON.stringify(paramsObj));

    const filterQueryList: any = [];

    obj.filter.filters.forEach((filter: any) => {
        filterQueryList.push(getQueryString(filter));
    })

    obj.filter.filters = filterQueryList.join(' and ');

    return obj;

}

const getQueryString = (filter: any) => {
    switch (filter.operator) {
        case 'contains':
            return `search.ismatch('${filter.value}*','${filter.field}')`
        case 'eq':
            // Ensure value is an array before using forEach
            const eqValues = Array.isArray(filter.value) ? filter.value : [filter.value];
            let queryStringOr: string = '';
            eqValues.forEach((val: string, index: number) => {
                queryStringOr += `${filter.field} eq '${val}'${index < eqValues.length - 1 ? ' or ' : ''}`
            })
            return `(${queryStringOr})`;
        case 'array eq':
            // Ensure value is an array before using forEach
            const arrayEqValues = Array.isArray(filter.value) ? filter.value : [filter.value];
            let queryString: string = '';
            arrayEqValues.forEach((val: string, index: number) => {
                queryString += `t eq '${val}'${index < arrayEqValues.length - 1 ? ' or ' : ''}`
            })
            return `${filter.field}/any(t: ${queryString})`;
        case 'ge':
            // Handle date fields for Updates (dateCreated, lastUpdatedArtefactDate)
            const greaterValue = (filter.field === "dateCreated" || filter.field === "dateModified" || filter.field === "lastUpdatedArtefactDate")
                ? filter.value + ':00Z'
                : filter.value;
            return `${filter.field} ge ${greaterValue}`;
        case 'le':
            // Handle date fields for Updates (dateCreated, lastUpdatedArtefactDate)
            const lesserValue = (filter.field === "dateCreated" || filter.field === "dateModified" || filter.field === "lastUpdatedArtefactDate")
                ? filter.value + ':59Z'
                : filter.value;
            return `${filter.field} le ${lesserValue}`;
        default:
            return ''
    }
}